import React from 'react';
import { Navigate, useParams } from 'react-router-dom';
import { serviceRequestDetail, serviceRequestEdit } from '../constants/routes';

export function LegacyRequestDetailRedirect() {
  const { id } = useParams();
  return <Navigate to={serviceRequestDetail(id)} replace />;
}

export function LegacyRequestEditRedirect() {
  const { id } = useParams();
  return <Navigate to={serviceRequestEdit(id)} replace />;
}
